// Vuex Store
import store from '../store/store'

export default (permissions) => {
  let canEnter = false
  const userDetails = store.state.auth.userDetails()

  if (userDetails) {
    //const userPermissions = userDetails.permissions
    const userPermissions = userDetails.optionTimeWebs

    if (!userPermissions || !permissions) {
      return canEnter
    }

    if (!Array.isArray(permissions)) {
      //console.log('canEnter 1')

      userPermissions.forEach(permission => {
        if (permission.name === permissions) {
          canEnter = permission.active === 'Y'
        }
      })

      //canEnter = userPermissions.includes(permissions)
    } else {
      //console.log('canEnter 2')

      permissions.forEach(permission1 => {
        userPermissions.forEach(permission2 => {
          if (permission2.name === permission1) {
            canEnter = permission2.active === 'Y'

            if (!canEnter) {
              return false
            }
          }
        })
      })

      /*permissions.forEach(permission => {
        if (userPermissions.includes(permission)) {
          canEnter = true
        }
      })*/
    }
  }

  //console.log('canEnter value =', canEnter)

  return canEnter
}
